import { createAppReducer, apiReducerSwitch } from 'lib/redux/reducerUtils'
import {
  CART_OFFER_COMPARISON_ADD_SELECTION,
  CART_OFFER_COMPARISON_REMOVE_SELECTION,
  CART_OFFER_COMPARISON_REPLACE_SELECTION,
  CART_OFFER_COMPARISON_CLEAR_ALL,
  API_CALL_REQUEST,
  API_CALL_FAILURE,
  API_CALL_SUCCESS,
} from 'actions/actionConstants'
import { MAX_COMPARISON_SELECTIONS } from 'constants/offer'
import { CREATE_CART_OFFER_COMPARISON_ITEM, FETCH_CART_OFFER_COMPARISON_ITEMS } from 'actions/apiActionConstants'

export const initialCartOfferComparisonState: App.CartOfferComparisonState = {
  spoofedSelections: [],
  activeComparison: undefined,
  loading: false,
}

const apiCalls = apiReducerSwitch<App.CartOfferComparisonState>({
  [FETCH_CART_OFFER_COMPARISON_ITEMS]: {
    request: () => ({
      loading: true,
      activeComparison: undefined,
      error: undefined,
    }),
    success: (_, action) => ({
      loading: false,
      activeComparison: action.data.result?.items ?? [],
      error: undefined,
    }),
    failure: (_, action) => ({
      loading: false,
      activeComparison: undefined,
      error: action.error,
    }),
  },
  [CREATE_CART_OFFER_COMPARISON_ITEM]: {
    request: () => ({
      loading: true,
      error: undefined,
    }),
    success: (_, action) => ({
      activeComparison: action.data.result?.items ?? [],
      loading: false,
      error: undefined,
    }),
    failure: (_, action) => ({
      loading: false,
      error: action.error,
    }),
  },
})

const cartOfferComparisonReducer = createAppReducer<App.CartOfferComparisonState>(
  initialCartOfferComparisonState,
  {
    [API_CALL_REQUEST]: apiCalls,
    [API_CALL_FAILURE]: apiCalls,
    [API_CALL_SUCCESS]: apiCalls,
    [CART_OFFER_COMPARISON_ADD_SELECTION]: (state, action) => {
      const isSelected = state.spoofedSelections.some((s) => s.selectionId === action.selection.selectionId)
      const canAddOffer = state.spoofedSelections.length < MAX_COMPARISON_SELECTIONS && !isSelected

      if (!canAddOffer) {
        return state
      }

      return {
        spoofedSelections: [...state.spoofedSelections, action.selection],
      }
    },
    [CART_OFFER_COMPARISON_REMOVE_SELECTION]: (state, action) => {
      const isSelected = state.spoofedSelections.some((s) => s.selectionId === action.selectionId)

      if (!isSelected) {
        return state
      }

      return {
        spoofedSelections: state.spoofedSelections.filter((s) => s.selectionId !== action.selectionId),
      }
    },
    [CART_OFFER_COMPARISON_REPLACE_SELECTION]: (state, action) => ({
      spoofedSelections: state.spoofedSelections.map((s) => {
        if (s.selectionId === action.selection.selectionId) {
          return action.selection
        } else {
          return s
        }
      }),
    }),
    [CART_OFFER_COMPARISON_CLEAR_ALL]: () => ({
      spoofedSelections: [],
    }),
  },
)

export default cartOfferComparisonReducer
